"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWindowFocused = exports.onWindowFocus = exports.onWindowBlur = void 0;
const gamepad_1 = require("./gamepad");
let windowFocused = true;
const onWindowBlur = () => {
    windowFocused = false;
    (0, gamepad_1.stopGamepadPolling)();
};
exports.onWindowBlur = onWindowBlur;
const onWindowFocus = () => {
    windowFocused = true;
    if ((0, gamepad_1.isGamepadPollingEnabled)()) {
        (0, gamepad_1.startGamepadPolling)();
    }
};
exports.onWindowFocus = onWindowFocus;
const isWindowFocused = () => windowFocused;
exports.isWindowFocused = isWindowFocused;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2luZG93LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvcmUvZm91bmRhdGlvbi93aW5kb3cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELHVDQUE2RjtBQUU3RixJQUFJLGFBQWEsR0FBRyxJQUFJLENBQUM7QUFFbEIsTUFBTSxZQUFZLEdBQUcsR0FBUyxFQUFFO0lBQ25DLGFBQWEsR0FBRyxLQUFLLENBQUM7SUFDdEIsSUFBQSw0QkFBa0IsR0FBRSxDQUFDO0FBQ3pCLENBQUMsQ0FBQztBQUhXLFFBQUEsWUFBWSxnQkFHdkI7QUFFSyxNQUFNLGFBQWEsR0FBRyxHQUFTLEVBQUU7SUFDcEMsYUFBYSxHQUFHLElBQUksQ0FBQztJQUNyQixJQUFJLElBQUEsaUNBQXVCLEdBQUUsRUFBRSxDQUFDO1FBQzVCLElBQUEsNkJBQW1CLEdBQUUsQ0FBQztJQUMxQixDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBTFcsUUFBQSxhQUFhLGlCQUt4QjtBQUVLLE1BQU0sZUFBZSxHQUFHLEdBQVksRUFBRSxDQUFDLGFBQWEsQ0FBQztBQUEvQyxRQUFBLGVBQWUsbUJBQWdDIn0=